import React from "react"

import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card"
import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from "@/components/ui/table"

interface TableMessageProps {
    message: string
}

const TableMessage: React.FC<TableMessageProps> = ({message}) => {
    try {
        const data = JSON.parse(message)

        if (!Array.isArray(data) || data.length === 0) {
            return (
                <Card>
                    <CardHeader>
                        <CardTitle>No data to display</CardTitle>
                    </CardHeader>
                </Card>
            )
        }

        const headers = Object.keys(data[0])

        return (
            <Card>
                <CardContent className="p-4">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                {headers.map((header) => (
                                    <TableHead key={header} className="font-semibold">
                                        {header}
                                    </TableHead>
                                ))}
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {data.map((row, index) => (
                                <TableRow key={index}>
                                    {headers.map((header) => (
                                        <TableCell key={`${index}-${header}`}>
                                            {typeof row[header] === "object" ? JSON.stringify(row[header]) : String(row[header])}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        )
    } catch (error) {
        return (
            <Card>
                <CardHeader>
                    <CardTitle>Invalid JSON data</CardTitle>
                </CardHeader>
            </Card>
        )
    }
}

export default TableMessage
